<template>
  <div class="cbg-content">
    <div class="bar_bg"></div>
    <div class="lt-left"></div>
    <div
      ref="cmain1"
      class="cmain"
      @mouseover="autoTimePaused = true"
      @mouseout="autoTimePaused = false"
    ></div>
    <div class="center_text">
      <p>{{ numformat(totalValue) }}</p>
      <span :title="defaultdata[0].value3">{{ defaultdata[0].value3 }}</span>
    </div>
  </div>
</template>

<script>
import * as methods from "../scope/method.js";
export default {
  name: "template.scope1.center5",
  props: {
    vdata: {
      type: [Array, String],
      default: () => []
    },
    jsondata: {
      type: [Array, String],
      default: () => []
    },
    scopedata: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      timer: null,
      defaultdata: [
        { value1: "A5.5民事案事件", value2: "1700", value3: "案件总数" },
        { value1: "A5.4人员失联/自 杀...", value2: "580" },
        { value1: "A5.1治安家事件", value2: "1800" },
        { value1: "A5.2刑事案件", value2: "600" },
        { value1: "A5.3交通案事件(非刑案)", value2: "500" }
      ],
      valueMap: [
        { name: "名称", key: "value1" },
        { name: "数值", key: "value2" },
        { name: "总数", key: "value3" }
      ],
      exceldata: [],
      apiconfig: {},
      isApi: false,
      scope: {},
      autoTimePaused: false,
      totalValue: null // 将总数赋值给totalValue
    };
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
  watch: {
    vdata(n) {
      if (n && n.length) {
        let vdatalist = n.filter(item => {
                    let vlist = Object.keys(item)
                    let isdata = false
                    vlist.forEach(del => {
                        if (item[del] == undefined) {
                            item[del] = ''
                        } else if (del && item[del]) {
                            isdata = true
                        }
                    })
                    if (vlist.length && isdata) return item
                })
                this.defaultdata = vdatalist
      }
    },
    jsondata(n) {
      this.exceldata = n;
    },
    defaultdata() {
      this.cDrawCircle();
    }
  },
  methods: {
    ...methods,
    cDrawCircle() {
      clearInterval(this.timer);
      this.timer = null;
      var echarts = require("echarts");
      var TmyChart = echarts.init(this.$refs.cmain1);
      const colorList = [
        "#004cc8",
        "#fff",
        "#00d9ff",
        "#01e6e7",
        "#00d486",
        "#b5e6ff",
        "#2cbeff",
        "#72f3ec"
      ];
      let data = this.defaultdata.map((item, i) => {
        if (item.value1 && (item.value2 || item.value2 == 0)) {
          return {
            name: item.value1,
            value: +item.value2,
            itemStyle: {
              color: colorList[i]
            }
          };
        }
      });
      let total = 0;
      data.forEach(item => {
        if (item && item.value) {
          total += item.value;
        }
      });
      this.totalValue = +total; // 将总数赋值给totalValue
      var Toption = {
        tooltip: {
          trigger: "item"
        },
        legend: {
          orient: "vertical", //文字 行 排放 默认列
          top: "center",
          right: "16%",
          itemHeight: 15, //图例的高度  文字左边那个
          itemWidth: 15,
          z: 5,
          textStyle: {
            //设置文本样式
            color: "#CBD8DE",
            lineHeight: 32,
            fontWeight: "400",
            fontSize: "14",
            // padding: [0, 0, 0, 10],
            rich: {
              a: {
                width: 140,
                padding: [0, -10, 0, 10],
                fontSize: 14
              },
              b: {
                padding: [0, 0, 0, 28],
                fontSize: 14
                // color: color,
              }
            }
          }, //图例的高度
          formatter: function(name) {
            let newName = name.length > 15 ? name.slice(0, 15) + "..." : name;
            const format = data.find(item => item.name == name);
            let percent = ((format.value / total) * 100).toFixed(2);
            // let color = format.itemStyle.color;
            // let richStyle = {
            //   ...Toption.legend.textStyle.rich,
            //   b: {
            //     padding: [0, 0, 0, 28],
            //     fontSize: 14,
            //     color: color,
            //   },
            // };
            // console.log(list, "list");

            // Toption.legend.textStyle.rich = richStyle;
            let arr = ["{a|" + newName + "}", "{b|" + percent + "%}"];
            return arr.join("    ");
          }
        },
        series: [
          {
            type: "pie",
            //选中ple的中间40-50
            center: ["30%", "44%"],
            radius: ["50%", "60%"],
            padAngle: 3,
            label: {
              show: false,
              position: "center"
            },
            // itemStyle: {
            //   normal: {
            //     // borderColor: "#000",
            //     borderColor: "trensparent",
            //     borderWidth: 3,
            //   },
            // },
            data: data
          }
        ]
      };
      Toption && TmyChart.setOption(Toption);
      this.timer = setInterval(function() {
        if (this.autoTimePaused) return; // 如果定时器暂停，则不执行后续逻辑
        TmyChart.clear();
        Toption && TmyChart.setOption(Toption);
      }, 5000);
    }
  },
  mounted() {
    if (this.vdata && this.vdata.length) {
      this.defaultdata = this.vdata;
    }
    if (this.jsondata && this.jsondata.length) {
      this.exceldata = this.jsondata;
    }
    this.setData()
    this.cDrawCircle();
  }
};
</script>

<style scoped lang="scss">
.cbg-content {
  width: 919px;
  height: 522px;
  position: absolute;
  //   top: -60px;
  //   left: 25px;
  display: flex;
  //   border: 1px solid red;
  pointer-events: auto;

  .bar_bg {
    width: 1117px;
    height: 180px;
    background: url("../../assets/temimg11/bar_bg.png") no-repeat center center;
    background-size: 100% 100%;
    position: absolute;
    bottom: 0;
    left: -103px;
  }
  .lt-left {
    width: 357px;
    height: 358px;
    position: absolute;
    left: calc(49.5% - 357px);
    top: calc(44% - (358px / 2));
    box-sizing: border-box;
    background: url("../../assets/temimg11/bar_cen.png") no-repeat;
    background-size: 100%;
  }

  .cmain {
    width: 100%;
    height: 100%;
  }

  .center_text {
    position: absolute;
    top: 46%;
    left: 30%;
    transform: translate(-50%, -50%);
    text-align: center;
    font-family: Source Han Sans CN;
    font-weight: 500;
    font-size: 41px;
    color: #ffffff;
    line-height: 48px;
    span {
      max-width: 140px;
      display: block;
      white-space: nowrap;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;

      font-family: Source Han Sans CN;
      font-weight: 400;
      font-size: 21px;
      color: #ffffff;
      line-height: 48px;
    }
  }
}
</style>
